<template>
  <div class="app">
    <RmHeader />
    <GlobalComponents />
    <div>
      <div
        v-if="isShowCategoriesMenu"
        class="is-shadow"
      />
      <div class="max-w-7xl mx-auto">
        <BannersSlider />
        <MainBanner />
      </div>
      <div class="content w-full max-w-screen-xl mx-auto">
        <NuxtPage />
      </div>
      <RmFooter />
    </div>
    <MobileNav class="md:hidden" />
  </div>
</template>

<script>
import RmFooter from '@/components/footer/index.vue'
import RmHeader from '@/components/header/index.vue'
import BannersSlider from '@/components/index/banners_slider.vue'
import MainBanner from '@/components/index/main_banner.vue'
import GlobalComponents from '@/components/layout/global_components.vue'
import MobileNav from '@/components/layout/mobile_nav.vue'
export default {
  components: {
    RmFooter,
    RmHeader,
    GlobalComponents,
    MobileNav,
    BannersSlider,
    MainBanner,
  },
  setup () {
    const { signOut } = useAuth()
    return {
      isShowCategoriesMenu: useGlobal().isShowCategoriesMenu,
      signOut,
    }
  },
  created () {
    if (this.$route.query.signin === 'true') {
      this.signOut()
      const fields = useStoreFields()
      fields.clearSubmittings()
      fields.clearBackendErrors()
    }
  },
  mounted () {
    if (this.$route.query.signin === 'true') {
      this.$modal.show('flow/auth')
    }
  },
}
</script>
